import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import FormSection from './FormSection';

/**
 * One section box of a record form: a Paper with an h6 header, matching the
 * Metadaten page, and the anchor the in-form nav jumps to.
 *
 * `titlePrefix` names the owning form's catalog ('planum.section',
 * 'photo.section', …) and the section id completes the key — which is what lets
 * every record dialog title its sections in its own words while the chrome
 * itself lives in one place.
 */
export default function FormSectionBox({
    titlePrefix,
    id,
    titleSlot,
    children
}: {
    titlePrefix: string;
    /** Also the anchor the in-form nav jumps to. */
    id: string;
    /** Beside the heading — see FormSection's `titleSlot`. */
    titleSlot?: ReactNode;
    children: ReactNode;
}) {
    return (
        <FormSection
            anchorId={id}
            title={<FormattedMessage id={`${titlePrefix}.${id}`} />}
            titleSlot={titleSlot}
        >
            {children}
        </FormSection>
    );
}
